import React, { useEffect, useRef, useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";

import { get, postJsonData } from "../network/ApiController";
import ApiEndpoints from "../network/ApiEndPoints";
import { apiErrorToast, okSuccessToast } from "../utils/ToastUtil";

import { useParams } from "react-router-dom";

const PaymentPage = () => {
  const { orderId } = useParams();

  const [txn, setTxn] = useState(null);
  const [request, setRequest] = useState(false);

  // 6 digit MPIN
  const [mpin, setMpin] = useState(["", "", "", "", "", ""]);

  const inputRefs = useRef([]);

  useEffect(() => {
    getPaymentDetails();
  }, []);

  const getPaymentDetails = () => {
    get(
      `${ApiEndpoints.SETU_PAYMENT_DETAILS}/${orderId}`,
      "",
      setRequest,

      (res) => {
        console.log("Payment Details Response:", res);

        if (res.status) {
          setTxn(res.data.data);
        }
      },

      (error) => {
        apiErrorToast(error);
      },
    );
  };

  // MPIN input handle
  const handleMpinChange = (value, index) => {
    // Sirf number allow
    if (!/^\d?$/.test(value)) {
      return;
    }

    const newMpin = [...mpin];
    newMpin[index] = value;

    setMpin(newMpin);

    // Agar digit enter hua to next block
    if (value && index < 5) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  // Backspace handle
  const handleMpinKeyDown = (e, index) => {
    if (e.key === "Backspace" && !mpin[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };

  const handlePayment = () => {
    const enteredMpin = mpin.join("");

    // MPIN validation
    if (enteredMpin.length !== 6) {
      apiErrorToast("Please enter 6 digit MPIN");
      return;
    }

    postJsonData(
      ApiEndpoints.SETU_PAYMENT_PROCESS,

      {
        order_id: orderId,
        mpin: enteredMpin,
      },

      setRequest,

      (res) => {
        console.log("Payment Process Response:", res);

        if (res?.status) {
          okSuccessToast("Payment Successful");

          if (res?.data?.redirect_url) {
            window.location.href = res.data.redirect_url;
          } else {
            apiErrorToast("Payment successful but redirect URL not received");
          }
        } else {
          apiErrorToast(res?.message || "Payment failed");
        }
      },

      (error) => {
        apiErrorToast(error);
      },
    );
  };

  const isMpinComplete = mpin.every((digit) => digit !== "");

  return (
    <Box
      sx={{
        width: "400px",
        maxWidth: "90%",
        margin: "50px auto",
        padding: "25px",
        boxShadow: 2,
        borderRadius: "10px",
      }}
    >
      <Typography variant="h5" sx={{ fontWeight: 600, textAlign: "center" }}>
        Dillipay Payment
      </Typography>

      {txn && (
        <>
          <Typography sx={{ mt: 2 }}>Order ID: {txn.order_id}</Typography>

          <Typography sx={{ mt: 1 }}>Amount: ₹{txn.amount}</Typography>

          <Typography sx={{ mt: 1 }}>
            Status: {txn.status ?? "PENDING"}
          </Typography>

          {/* MPIN */}
          <Typography
            sx={{
              mt: 4,
              mb: 1.5,
              fontWeight: 600,
            }}
          >
            Enter 6 Digit MPIN
          </Typography>

          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              gap: "10px",
            }}
          >
            {mpin.map((digit, index) => (
              <input
                key={index}
                ref={(el) => {
                  inputRefs.current[index] = el;
                }}
                type="password"
                inputMode="numeric"
                maxLength={1}
                value={digit}
                onChange={(e) => handleMpinChange(e.target.value, index)}
                onKeyDown={(e) => handleMpinKeyDown(e, index)}
                style={{
                  width: "42px",
                  height: "48px",
                  textAlign: "center",
                  fontSize: "22px",
                  border: "1px solid #ccc",
                  borderRadius: "6px",
                  outline: "none",
                }}
              />
            ))}
          </Box>

          <Button
            variant="contained"
            fullWidth
            sx={{ mt: 4 }}
            onClick={handlePayment}
            disabled={request || !isMpinComplete}
          >
            {request ? "Processing..." : "Pay Now"}
          </Button>
        </>
      )}
    </Box>
  );
};

export default PaymentPage;
